import {
  connectQZ,
  printQZ,
} from "../qz";
import {
  createPrintError,
  createPrintResult,
  PRINT_ERROR_CODES,
} from "../contracts";
import { renderEscPos } from "../escpos";

export async function printQZAdapter({ job }) {
  if (!job?.printer?.name) {
    throw createPrintError(
      PRINT_ERROR_CODES.PRINTER_NOT_CONFIGURED,
      "Printer QZ belum dipilih.",
      { job, adapter: "qz" }
    );
  }

  try {
    await connectQZ();

    const payload = renderEscPos(job.content || {}, job.printer);

    const data = [
      {
        type: "raw",
        format: "command",
        flavor: "hex",
        data: payload,
      },
    ];

    const result = await printQZ(job.printer.name, data);

    return createPrintResult({
      job,
      success: true,
      adapter: "qz",
      transport_result: result,
    });
  } catch (error) {
    throw createPrintError(
      error?.code || PRINT_ERROR_CODES.CONNECTION_FAILED,
      error?.message || "Gagal mencetak melalui QZ.",
      {
        job,
        adapter: "qz",
        cause: error,
      }
    );
  }
}
